import React, { Component } from "react";
import Pagination from '@mui/material/Pagination';
import Select from "react-select";
import Navbar from "../../components/Navbar.js";
import "../../components/global.js";
import "../../assets/css/bootstrap.css";

// เพิ่ม loading เข้ามาใน import
import { tokens, select_style, toFixed, GET, total, format_date, getStorage, roundToTwo, loading } from "../../components/CustomComponent.js";

export default class WaterPaymentInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      filter_address_number: null,
      data: null,
      data_address: [],
    };
  }

  async componentDidMount() {
    loading(false); // ปิด loading ตั้งแต่เข้ามาหน้าครั้งแรก
    await this.GetAddressAll();
    await this.GetAll();
  }

  GetAddressAll = async () => {
    let result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({
        data_address: result.data.data.map(item => ({
          value: item.address_number,
          label: `อาคาร ${item.building} ห้อง ${item.address_number}`
        }))
      });
    }
  };

  GetAll = async () => {

  let fields = [
    { k: "water_bill", sk: "s_water_bill" }, { k: "waste_cost", sk: "s_waste_cost" },
    { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" }, { k: "common_expenses", sk: "s_common_expenses" },
    { k: "cable_cost", sk: "s_cable_cost" }, { k: "fire_cost", sk: "s_fire_cost" },
    { k: "other_income", sk: "s_other_income" }, { k: "add_debt", sk: "s_add_debt" },
    { k: "meter_connect_cost", sk: "s_meter_connect_cost" }, { k: "reduce_debt", sk: "s_reduce_debt", m: -1 },
    { k: "total_cost_late", sk: "s_late_payment", pk: "late_payment" }
  ];
    loading(true);
    let res = await GET(tokens, `v1/TH/record-receipt/filter-search/page/0/${getStorage("project_id")}`, {
      address_number: this.state.filter_address_number?.value || "",
    });

    if (res?.status) {
      let rawData = res.data.data_water || [];
      for (let item of rawData) {
          // transaction_payments
          if (item.transaction_payments?.length > 0) {
              // s_add_debt
              // s_cable_cost
              // s_common_expenses
              // s_equipment_maintenance_fee
              // s_fire_cost
              // s_late_payment
              // s_meter_connect_cost
              // s_other_income
              // s_reduce_debt
              // s_waste_cost
              // s_water_bill
              if (item.transaction_payments.some((p) => p.s_water_bill)) {
                  item.water_bill = 0;
              }
              if (item.transaction_payments.some((p) => p.s_waste_cost)) {
                  item.waste_cost = 0;
              }
              if (item.transaction_payments.some((p) => p.s_reduce_debt)) {
                  item.reduce_debt = 0;
              }
              if (item.transaction_payments.some((p) => p.s_other_income)) {
                  item.other_income = 0;
              }
              if (item.transaction_payments.some((p) => p.s_meter_connect_cost)) {
                  item.meter_connect_cost = 0;
              }
              if (item.transaction_payments.some((p) => p.s_late_payment)) {
                  item.total_cost_late = 0;
              }
              if (item.transaction_payments.some((p) => p.s_fire_cost)) {
                  item.fire_cost = 0;
              }
              if (item.transaction_payments.some((p) => p.s_equipment_maintenance_fee)) {
                  item.equipment_maintenance_fee = 0;
              }
              if (item.transaction_payments.some((p) => p.s_common_expenses)) {
                  item.common_expenses = 0;
              }
              if (item.transaction_payments.some((p) => p.s_cable_cost)) {
                  item.cable_cost = 0;
              }
              if (item.transaction_payments.some((p) => p.s_add_debt)) {
                  item.add_debt = 0;
              }
              item.total_amount =
                  item.water_bill +
                  item.waste_cost +
                  item.other_income +
                  item.meter_connect_cost +
                  item.total_cost_late +
                  item.fire_cost +
                  item.equipment_maintenance_fee +
                  item.common_expenses +
                  item.cable_cost +
                  item.add_debt -
                  item.reduce_debt;
          }

          // writeoff_list
          if (item.writeoff_list?.length > 0) {
              if (item.writeoff_list.some((p) => p.s_water_bill)) {
                  item.water_bill = 0;
              }
              if (item.writeoff_list.some((p) => p.s_waste_cost)) {
                  item.waste_cost = 0;
              }
              if (item.writeoff_list.some((p) => p.s_reduce_debt)) {
                  item.reduce_debt = 0;
              }
              if (item.writeoff_list.some((p) => p.s_other_income)) {
                  item.other_income = 0;
              }
              if (item.writeoff_list.some((p) => p.s_meter_connect_cost)) {
                  item.meter_connect_cost = 0;
              }
              if (item.writeoff_list.some((p) => p.s_late_payment)) {
                  item.total_cost_late = 0;
              }
              if (item.writeoff_list.some((p) => p.s_fire_cost)) {
                  item.fire_cost = 0;
              }
              if (item.writeoff_list.some((p) => p.s_equipment_maintenance_fee)) {
                  item.equipment_maintenance_fee = 0;
              }
              if (item.writeoff_list.some((p) => p.s_common_expenses)) {
                  item.common_expenses = 0;
              }
              if (item.writeoff_list.some((p) => p.s_cable_cost)) {
                  item.cable_cost = 0;
              }
              if (item.writeoff_list.some((p) => p.s_add_debt)) {
                  item.add_debt = 0;
              }
              item.total_amount =
                  item.water_bill +
                  item.waste_cost +
                  item.other_income +
                  item.meter_connect_cost +
                  item.total_cost_late +
                  item.fire_cost +
                  item.equipment_maintenance_fee +
                  item.common_expenses +
                  item.cable_cost +
                  item.add_debt -
                  item.reduce_debt;
          }
      }
      rawData.sort((a, b) => new Date(b.datetime_create) - new Date(a.datetime_create));

      // ช่องนี้จบแล้วหรือยัง — ยึด transaction_payments/writeoff_list เท่านั้น ไม่อ่าน s_* ระดับงวด
      // หลังยกเลิกการตัดหนี้/ยกเลิกใบเสร็จ backend ไม่ได้ล้าง s_* ทำให้ยอดที่กลับมาค้างหายจากยอดรวม
      const isSettled = (item, sk) =>
        [item.transaction_payments, item.writeoff_list].some((list) => list?.some((p) => p[sk]));

      const groupedData = Object.values(rawData.reduce((acc, item) => {
        const key = `${item.address_number}_${item.ref_customer_id}`;
        let baseAmount = 0;

        fields.forEach(({ k, sk, m = 1 }) => {
          item[sk] = isSettled(item, sk); // sync ให้ตาราง/ยอดรวมใช้สถานะเดียวกัน
          if (!item[sk]) baseAmount += Number(item[k] || 0) * m;
        });

        const itemLateFee = !item.s_late_payment ? Number(item.total_cost_late || 0) : 0;

        if (!acc[key]) {
          acc[key] = { ...item, count_installment: 1, total_amount: baseAmount, overdue_amount: 0, total_cost_late: itemLateFee };
        } else {
          acc[key].count_installment += 1;
          acc[key].overdue_amount += baseAmount;
          acc[key].meter_connect_cost += Number(item.meter_connect_cost || 0);
        }
        return acc;
      }, {}));

      let filteredData = groupedData.sort(this.fieldSorter());

      this.setState({
        data: filteredData
      });
    }
    loading(false);
  };

  fieldSorter = () => (a, b) => {
    const [pA, nA] = a.address_number.split('/').map(Number);
    const [pB, nB] = b.address_number.split('/').map(Number);
    return pA !== pB ? pA - pB : nA - nB;
  };

  render() {
    const { data, filter_address_number, data_address, page } = this.state;
    const fmt = (val) => val ? toFixed(val) : "0.00";

    return (
        <div className="w-100 min-vh-100 fade-in">
            <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ข้อมูลค่าใช้จ่ายและการจัดเก็บค่าใช้จ่ายทั้งหมด" />

            <div className="body">
                <div className="p-3">
                    <div className="card border-0 p-3">
                        <h4 className="mb-3">
                            <b>ข้อมูลค่าใช้จ่ายและการจัดเก็บค่าใช้จ่ายทั้งหมด</b>
                        </h4>

                        <div className="d-flex row mx-0 mb-3">
                            <Select
                                className="form-control bg-contain border-0 select-search wpx-200 mx-1"
                                styles={select_style}
                                options={data_address}
                                onChange={(e) => this.setState({ filter_address_number: e })}
                                value={filter_address_number}
                            />
                            <button className="btn btn-primary px-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                                ค้นหา
                            </button>
                            <button className="btn btn-outline-primary px-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>
                                รีเซ็ท
                            </button>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-borderless table-striped text-nowrap">
                                <thead className="bg-dark-blue text-white">
                                    <tr className="bg-primary">
                                        <th className="text-center">ตัดลูกหนี้</th>
                                        <th className="text-left">บ้านเลขที่</th>
                                        <th className="text-left">ชื่อ-นามสกุล</th>
                                        <th className="text-center">วันที่จดมาตร</th>
                                        <th className="text-right">เลขมาตรครั้งนี้</th>
                                        <th className="text-right">เลขมาตรครั้งก่อน</th>
                                        <th className="text-right">จำนวนหน่วยที่ใช้</th>
                                        <th className="text-right">ค่าน้ำประปา</th>
                                        <th className="text-right">ค่ารักษาอุปกรณ์น้ำ</th>
                                        <th className="text-right">ค่าส่วนกลาง</th>
                                        <th className="text-right">ค่าขยะ</th>
                                        <th className="text-right">ค่าเคเบิล</th>
                                        <th className="text-right">ค่าใช้จ่ายอื่นๆ</th>
                                        <th className="text-right">ค่าเบี้ยประกัน</th>
                                        <th className="text-right">เพิ่ม/ลดหนี้</th>
                                        <th className="text-right">ค่าต่อกลับมิเตอร์</th>
                                        <th className="text-right">ค่าปรับชำระล่าช้า</th>
                                        <th className="text-right">รวม (บาท)</th>
                                        <th className="text-center">งวด</th>
                                        <th className="text-right">จำนวนเงินค้างชำระ</th>
                                        <th className="text-right">รวมเป็นเงิน</th>
                                        <th className="text-left">เลขที่รับใบเสร็จ</th>
                                        <th className="text-center">วันที่ใบเสร็จรับเงิน</th>
                                        <th className="text-left">รายละเอียด</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!data?.length ? (
                                        <tr>
                                            <td colSpan={21} className="text-center py-3">
                                                {" "}
                                                ไม่มีข้อมูล{" "}
                                            </td>
                                        </tr>
                                    ) : (
                                        data.slice((page - 1) * 10, page * 10).map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <label
                                                        className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer"
                                                        onClick={() => (window.location.href = `/write-of-dept?address_number=${item.address_number}`)}
                                                    >
                                                        <span className="icon text-primary">{"\uf543"}</span>
                                                    </label>
                                                </td>
                                                <td className="text-left">{item.address_number || "-"}</td>
                                                <td className="text-left">{item.full_name || "-"}</td>
                                                <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-right">{item.current_gauge_number || "0"}</td>
                                                <td className="text-right">{item.last_gauge_number || "0"}</td>
                                                <td className="text-right">{item.unit_used || "0"}</td>
                                                <td className="text-right">{fmt(item.water_bill)}</td>
                                                <td className="text-right">{fmt(item.equipment_maintenance_fee)}</td>
                                                <td className="text-right">{fmt(item.common_expenses)}</td>
                                                <td className="text-right">{fmt(item.waste_cost)}</td>
                                                <td className="text-right">{fmt(item.cable_cost)}</td>
                                                <td className="text-right">{fmt(item.other_income)}</td>
                                                <td className="text-right">{fmt(item.fire_cost)}</td>
                                                <td className="text-right">{fmt((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                                                <td className="text-right">{fmt(item.meter_connect_cost)}</td>
                                                <td className="text-right">{fmt(item.total_cost_late)}</td>
                                                <td className="text-right">{fmt(item.total_amount)}</td>
                                                <td className="text-center">{item.count_installment || "0"}</td>
                                                <td className="text-right">{toFixed(item.overdue_amount || 0)}</td>
                                                <td className="text-right">{toFixed((item.total_amount || 0) + (item.overdue_amount || 0))}</td>
                                                <td className="text-center">{item.ref_iw_number || "-"}</td>
                                                <td className="text-center">{item.ref_datetime_bill ? format_date(item.ref_datetime_bill, "dd/mm/yyyy") : "-"}</td>
                                                <td className="text-left">-</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* แก้ไขให้ Pagination ทำงานแบบ Client-side อย่างถูกต้อง ไม่ต้องเรียก this.GetAll() ซ้ำ */}
                        {data?.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                                <label>
                                    แสดง {(page - 1) * 10 + 1} ถึง {Math.min(page * 10, data.length)} รายการ จาก {data.length} รายการ
                                </label>
                                <Pagination count={Math.ceil(data.length / 10)} page={page} color="primary" showFirstButton showLastButton onChange={(e, val) => this.setState({ page: val })} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
  }
}